import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledGrid = styled.dl`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(160px, 100%), 1fr));
  gap: 18px 24px;
  margin: 0;

  dt {
    margin-bottom: 4px;
    font-size: 12px;
    color: var(--dimGray);
  }

  .info-full {
    grid-column: 1 / -1;
  }

  // Démarre un nouveau groupe d'infos sur sa propre ligne
  .info-new-row {
    grid-column-start: 1;
  }

  .info-extra {
    max-width: 100%;
    margin-top: 6px;
  }

  // Boutons dans une valeur (« Voir plus »…) : jamais plus larges que la cellule
  dd .ant-btn {
    max-width: 100% !important;
    height: auto !important;
    white-space: normal !important;
    text-align: left;
  }

  dd {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--textColor);
    overflow-wrap: anywhere;
  }
`;

/**
 * Grid of label / value pairs used in the detail pages.
 * @component
 * @param {Object} props - The component props.
 * @param {Object[]} props.items - Items: { label, content, extra, full, newRow }.
 * @returns {JSX.Element} - The InfoGrid component.
 */
export const InfoGrid = ({ items }) => (
  <StyledGrid>
    {items.map(({ label, content, extra, full, newRow }, index) => (
      <div
        // eslint-disable-next-line react/no-array-index-key
        key={`${label}-${index}`}
        className={
          [full && 'info-full', newRow && 'info-new-row']
            .filter(Boolean)
            .join(' ') || undefined
        }
      >
        <dt>{label}</dt>
        <dd>
          {content || '-'}
          {extra && <div className="info-extra">{extra}</div>}
        </dd>
      </div>
    ))}
  </StyledGrid>
);

InfoGrid.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      content: PropTypes.node,
      extra: PropTypes.node,
      full: PropTypes.bool,
      newRow: PropTypes.bool
    })
  ).isRequired
};
